// Backslash-escapes the characters that are special in the WIFI: payload format.
const escapeWifi = (value) => value.replace(/([\\;,:"])/g, "\\$1");

// Builds the string phones scan to join a network: WIFI:T:WPA;S:<ssid>;P:<password>;H:true;;
export const buildWifiPayload = ({ ssid, password, security, hidden }) => {
  const open = security === "nopass";
  let payload = `WIFI:T:${security};S:${escapeWifi(ssid)};`;
  if (!open) payload += `P:${escapeWifi(password)};`;
  if (hidden) payload += "H:true;";
  return payload + ";";
};
